"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = require("@emotion/core");

var _propTypes = require("prop-types");

var _react = require("react");

var _Book = _interopRequireDefault(require("@material-ui/icons/Book"));

var _PackageSelectorBox = _interopRequireDefault(require("../PackageSelectorBox/PackageSelectorBox"));

var _ButtonNew = _interopRequireDefault(require("../ButtonNew/ButtonNew"));

var _Placeholder = _interopRequireDefault(require("../Placeholder/Placeholder"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var SandboxDrawerExplore = function SandboxDrawerExplore(props) {
  var data = props.data,
      selectedPackage = props.selectedPackage,
      toggleLayerSelector = props.toggleLayerSelector,
      updatePackage = props.updatePackage,
      errors = props.errors,
      toggleContributeDialog = props.toggleContributeDialog;
  return (0, _core.jsx)(_react.Fragment, null, (0, _core.jsx)("div", {
    css: (0, _core.css)("\n            position: relative;\n            z-index: 900;\n          ")
  }, (0, _core.jsx)("div", {
    css: (0, _core.css)("margin: 0 10px;")
  }, (0, _core.jsx)("h2", null, (0, _core.jsx)(_Book["default"], {
    fontSize: "large",
    css: (0, _core.css)("\n                vertical-align: middle;\n                padding-right: 2px;\n              ")
  }), "Collections"), (0, _core.jsx)(_Placeholder["default"], null, (0, _core.jsx)(_ButtonNew["default"], {
    label: "Learn How To Add Your Data",
    onClick: toggleContributeDialog
  }))), (0, _core.jsx)(_PackageSelectorBox["default"], {
    selectedPackages: selectedPackage,
    packages: data && data.packages.length ? data.packages : [],
    onChange: function onChange(name) {
      updatePackage({
        displayName: name
      });
      toggleLayerSelector();
    }
  })), errors ? (0, _core.jsx)("div", {
    css: (0, _core.css)("\n                margin: auto;\n                width: 80%;\n              ")
  }, (0, _core.jsx)("p", null, "There was an error fetching the data.")) : null);
};

var _default = SandboxDrawerExplore;
exports["default"] = _default;
SandboxDrawerExplore.propTypes = {
  data: (0, _propTypes.shape)({}),
  selectedPackage: _propTypes.string,
  updatePackage: _propTypes.func,
  toggleLayerSelector: _propTypes.func,
  toggleContributeDialog: _propTypes.bool,
  errors: _propTypes.bool
};